import { createStore } from "redux";
import rootReducer from "./reducers/";

const loadCart = () => {
  try {
    const data = localStorage.getItem('cart');
    if (!data) return undefined;
    const cart = JSON.parse(data).map(({ product_name, count, price }) => ({ product_name, count, price }));
    return { cartReducer: cart };
  } catch {
    return undefined;
  }
};

const store = createStore(rootReducer, loadCart());

store.subscribe(() => {
  try {
    localStorage.setItem('cart', JSON.stringify(store.getState().cartReducer));
  } catch {
    // ignore
  }
});

export default store;
